import Vue from 'vue'

const Common = {
    message: message,
    notify: notify,

    // 常用工具函数
    checkEmail,
    checkEmailOrPhone,
    toMoney,
    moneyConvert,
    parseFormatNum,
    parseToStar,
    checkParamsHasNull,
    clone,
    merge,
    getNChar,
    isNull,
    isChinese,
    isChar,
    maxNum,
    randomNick,
    formatMoney,
    generateChinese,
    generateSentence,
    generateQuote,
    generateWords,
    generateRandomWords,
    capitalizeWords,
    generateRandomTimestamps,
    hasParamOfUrl,
    getUrlParams,
    getUrlParam,
    copy
}

function message(text) {
    Vue.prototype.$message({
        message: text,
        type: 'success'
    })
}

function notify(text) {
    Vue.prototype.$notify({
        message: text,
    })
}

function checkParamsHasNull(o, str) {
    let flag = false

    str.split(',').map(item => {
        if (o[item] === undefined || o[item] === null || o[item] === '') {
            flag = true
        }
    })
    return flag
}

function checkEmail(p) {
    return /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(p)
}

function checkEmailOrPhone(p) {
    return /^1[3456789]\d{9}$/.test(p) || /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/.test(p)
}


function toMoney(e) {
    let realVal = ''
    if (e !== '') {
        realVal = Math.floor(e * 100) / 100
    } else {
        realVal = '--'
    }
    return realVal
}

function parseFormatNum(number, n) {
    if (n != 0) {
        n = (n > 0 && n <= 20) ? n : 2
    }
    number = parseFloat((number + "").replace(/[^\d\.-]/g, "")).toFixed(n) + ""
    let sub_val = number.split(".")[0].split("").reverse()
    let sub_xs = number.split(".")[1]
    let show_html = ""
    for (let i = 0; i < sub_val.length; i++) {
        show_html += sub_val[i] + ((i + 1) % 3 == 0 && (i + 1) != sub_val.length ? "," : "")
    }
    if (n == 0) {
        return show_html.split("").reverse().join("")
    } else {
        return show_html.split("").reverse().join("") + "." + sub_xs
    }
}

function parseToStar(n, nStar) {
    n = n.toString()
    if (n.length > 1) {
        return n.substring(0, 1) + getNChar('*', nStar || n.length - 2) + n.substring(n.length - 1)
    }
    return n
}

function moneyConvert(m) {
    if (m >= 1000 && m < 1000000) {
        let d = (m / 1000).toFixed(2)
        return d + ' K'
    } else if (m >= 1000000 && m < 1000000000) {
        let d = (m / 1000000).toFixed(2)
        return d + ' M'
    } else if (m >= 1000000000) {
        let d = (m / 1000000000).toFixed(2)
        return d + ' B'
    }
    return m
}


function clone(obj) {
    return JSON.parse(JSON.stringify(obj))
}

function merge(obj1, ...objs) {
    let isMerge = false; // 默认不覆盖

    // 如果最后一个参数是布尔值，则认为它是isMerge标志
    if (typeof objs[objs.length - 1] === 'boolean') {
        isMerge = objs.pop(); // 弹出最后一个参数并赋值给isMerge
    }

    // 遍历所有需要合并的对象
    objs.forEach(obj => {
        if (typeof obj === 'object' && obj !== null) {
            Object.entries(obj).forEach(([key, value]) => {
                // 根据isMerge标志决定是否覆盖
                if (isMerge || !obj1.hasOwnProperty(key)) {
                    Vue.prototype.$set(obj1, key, value); // 使用Vue的$set方法确保响应性
                }
            });
        }
    });
}

function getNChar(c, n) {
    let s = ''
    for (let i = 0; i < n; i++) s += c
    return s
}

function isNull(input) {
    return input == null || input == undefined || input == '' || input == 'undefined' || input == 'null'
}

function isChinese(temp) {
    return !(/[^\u4E00-\u9FA5]/.test(temp))
}

function isChar(char) {
    return (/[A-Za-z]/.test(char))
}

function maxNum(val, max) {
    return val > max ? max : val
}

function randomNick(prefix, randomLength) {
    // 第一个参数为你想生成的固定的文字开头比如: 微信用户xxxxx
    // 第二个为你想生成出固定开头文字外的随机长度
    // 兼容更低版本的默认值写法
    prefix === undefined ? prefix = "" : prefix
    randomLength === undefined ? randomLength = 8 : randomLength
    // 设置随机用户名
    // 用户名随机词典数组
    let nameArr = [
        [1, 2, 3, 4, 5, 6, 7, 8, 9, 0],
        ["a", "b", "c", "d", "e", "f", "g", "h", "i", "g", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u",
            "v", "w", "x", "y", "z"
        ]
    ]
    // 随机名字字符串
    let name = prefix
    // 循环遍历从用户词典中随机抽出一个
    for (var i = 0; i < randomLength; i++) {
        // 随机生成index
        let index = Math.floor(Math.random() * 2)
        let zm = nameArr[index][Math.floor(Math.random() * nameArr[index].length)]
        // 如果随机出的是英文字母
        if (index === 1) {
            // 则百分之50的概率变为大写
            if (Math.floor(Math.random() * 2) === 1) {
                zm = zm.toUpperCase()
            }
        }
        // 拼接进名字变量中
        name += zm
    }
    // for (let i = 0; i < 15; i++) console.log('随机昵称：', randomNick('dg_', 8))
    // 将随机生成的名字返回
    return name
}

function formatMoney(s, n) {
    n = n > 0 && n <= 20 ? n : 2;
    s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
    var l = s.split(".")[0].split("").reverse(), r = s.split(".")[1];
    let t = "";
    for (let i = 0; i < l.length; i++) {
        t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? "," : "");
    }
    return t.split("").reverse().join("") + "." + r;
}

function generateChinese(min, max) {
    let text = "";
    const MIN_LENGTH = min;
    const MAX_LENGTH = max;
    const CHINESE_START = 0x4e00;
    const CHINESE_END = 0x9fff;

    const length = Math.floor(
        Math.random() * (MAX_LENGTH - MIN_LENGTH + 1) + MIN_LENGTH
    );

    for (let i = 0; i < length; i++) {
        const charCode = Math.floor(
            Math.random() * (CHINESE_END - CHINESE_START + 1) + CHINESE_START
        );
        text += String.fromCharCode(charCode);
    }

    return text;
}

function generateSentence() {
    const words = [
        "我", "你", "他", "她", "它", "是", "的", "了", "在", "和", "有", "不", "我国", "一位", "一只", "一只名为",
        "拥有", "丰富的", "知识和", "技能", "他/她", "常常", "在", "做", "一些", "非常有意义的", "工作", "这让他们感到",
        "无比的", "自豪", "也让", "他们", "收获", "了", "成就感", "和", "快乐", "同时", "他们", "也", "经常", "去", "旅行",
        "感受", "不同的", "文化", "并", "结交", "新的", "朋友", "这", "让他们觉得", "自己", "是", "生活", "中", "最幸福的"
    ];

    const MIN_LENGTH = 20;
    const MAX_LENGTH = 30;
    const length = Math.floor(
        Math.random() * (MAX_LENGTH - MIN_LENGTH + 1) + MIN_LENGTH
    );

    let sentence = "";
    while (sentence.length < length) {
        const word = words[Math.floor(Math.random() * words.length)];
        if ((sentence + word).length > length) {
            break;
        }
        sentence += word;
    }

    return sentence;
}

function generateQuote() {
    const quotes = [
        "学而不思则殆，思而不学则怠。",
        "知己知彼，百战不殆。",
        "天行健，君子以自强不息；地势坤，君子以厚德载物。",
        "吾生也有涯，而知也无涯。以有涯随无涯，殆已。",
        "天生我材必有用。",
        "欲穷千里目，更上一层楼。",
        "书山有路勤为径，学海无涯苦作舟。",
        "海纳百川，有容乃大；壁立千仞，无欲则刚。",
        "人生自古谁无死，留取丹心照汗青。",
        "不积跬步无以至千里，不积小流无以成江海。",
    ];

    const MIN_LENGTH = 20;
    const MAX_LENGTH = 30;
    const length = Math.floor(
        Math.random() * (MAX_LENGTH - MIN_LENGTH + 1) + MIN_LENGTH
    );
    const index = Math.floor(Math.random() * quotes.length);
    let quote = quotes[index];
    while (quote.length > length) {
        quote = quotes[Math.floor(Math.random() * quotes.length)];
    }

    return quote;
}

// function generateRandomWords(n) {
// 	const words = [];
//
// 	for (let i = 0; i < n; i++) {
// 		const alphabets = 'abcdefghijklmnopqrstuvwxyz';
//
// 		const randomWord = alphabets[Math.floor(Math.random() * 26)] +
// 			Math.random().toString(36).substring(2, 8);
//
// 		const capitalizedWord = randomWord.charAt(0).toUpperCase() + randomWord.slice(1);
// 		words.push(capitalizedWord);
// 	}
//
// 	return words.join(' ');
// }
// function generateRandomWords(min, max) {
// 	const numWords = Math.floor(Math.random() * (max - min + 1) + min);
//
// 	const words = [];
// 	for (let i = 0; i < numWords; i++) {
// 		let word = '';
// 		for (let j = 0; j < Math.floor(Math.random() * 10 + 1); j++) {
// 			const code = Math.floor(Math.random() * 26 + 97);
// 			word += String.fromCharCode(code);
// 		}
// 		words.push(word.charAt(0).toUpperCase() + word.slice(1));
// 	}
//
// 	return words.join(' ');
// }
// async function generateRandomWords(min, max) {
// 	const numWords = Math.floor(Math.random() * (max - min + 1) + min);
//
// 	const words = [];
// 	for (let i = 0; i < numWords; i++) {
// 		const response = await fetch('https://random-word-api.herokuapp.com/word?number=1');
// 		const data = await response.json();
// 		const word = data[0].charAt(0).toUpperCase() + data[0].slice(1);
// 		words.push(word);
// 	}
//
// 	return words.join(' ');
// }
function generateRandomWords(min, max) {
    // 定义一个英文单词数组
    const words = [
        'abacus', 'acumen', 'anatomy', 'balcony', 'bungalow', 'bygone', 'canvas', 'cohesive', 'communal', 'corpulent', 'cutlery', 'dagger', 'dashboard', 'diligent', 'dividend', 'document', 'eclectic', 'eccentric', 'emperor', 'evasive', 'exotic', 'fervid', 'futile', 'gargantuan', 'glamorous', 'gluttony', 'gyrate', 'halcyon', 'hazelnut', 'hysteria', 'iconic', 'immobile', 'infamous', 'invincible', 'jagged', 'juvenile', 'kaleidoscope', 'kettle', 'knead', 'knob', 'kwashiorkor', 'lament', 'lavender', 'lexicon', 'limousine', 'loathe', 'loquacious', 'lubberly', 'maestro', 'marzipan', 'menagerie'
    ]

    // 随机生成单词数量
    const numWords = Math.floor(Math.random() * (max - min + 1) + min);

    // 打乱单词数组
    const shuffledWords = words.sort(() => Math.random() - 0.5);

    // 选取前 numWords 个单词，然后将首字母大写并拼接起来
    const selectedWords = shuffledWords.slice(0, numWords).map((word) => {
        return word.charAt(0).toUpperCase() + word.slice(1);
    });

    // 用空格连接单词并返回结果
    return selectedWords.join(' ');
}

function generateWords(m, n) {
    let wordList = "";
    let alphabet = "abcdefghijklmnopqrstuvwxyz";

    let randomNum = Math.round(Math.random() * (n - m) + m);

    for (let i = 0; i < randomNum; i++) {
        let length = Math.floor(Math.random() * 10) + 1; // 1-10个字符

        let word = "";
        for (let j = 0; j < length; j++) {
            let index = Math.floor(Math.random() * alphabet.length);
            let letter = alphabet.charAt(index);
            word += letter;
        }

        let capitalized = word.charAt(0).toUpperCase() + word.slice(1);

        wordList += (capitalized + " ");
    }

    return wordList.trim();
}

function capitalizeWords(str) {
    // 将所有单词转换为小写，然后按空格分割字符串
    let words = str.toLowerCase().split(' ');

    // 循环遍历每个单词并将其首字母大写
    for (let i = 0; i < words.length; i++) {
        words[i] = words[i].charAt(0).toUpperCase();
    }

    // 将单词重新组合成一个字符串，并用空格分隔它们
    return words.join('');
}

function generateRandomTimestamps() {
    const maxInterval = 30; // 最大天数间隔
    const now = new Date();
    const startTimestamp = now.getTime() + Math.floor(Math.random() * 86400000); // 生成不早于当前时间的随机开始时间戳
    const dayInterval = Math.floor(Math.random() * maxInterval) + 1; // 生成随机间隔天数，不超过最大间隔天数
    const endTimestamp = startTimestamp + dayInterval * 86400000; // 计算结束时间戳
    const startDate = new Date(startTimestamp); // 将开始时间戳转换为日期对象
    const endDate = new Date(endTimestamp); // 将结束时间戳转换为日期对象

    function formatTimestamp(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}${month}${day}`;
    }

    return [formatTimestamp(startDate), formatTimestamp(endDate)];
}

function hasParamOfUrl(url, paramName) {
    return url.endsWith(paramName)
}

function getUrlParams(url = window.location.href) {
    // 创建一个对象存储解析后的参数
    const params = {};
    // 确保URL是字符串类型
    if (typeof url !== 'string') return params;

    // 获取URL中的查询字符串部分
    const queryString = url.split('?')[1];
    if (queryString) {
        // 按 '&' 分割每个键值对
        const pairs = queryString.split('&');
        for (let pair of pairs) {
            // 按 '=' 分割键和值
            const [key, value] = pair.split('=');
            // 解码URIComponent并存入对象
            params[decodeURIComponent(key)] = decodeURIComponent(value || '');
        }
    }
    return params;
}

function getUrlParam(paramName, url = window.location.href) {
    // 创建一个 URL 对象来解析传入的 URL
    const parsedUrl = new URL(url);

    // 获取 URL 中的所有查询参数
    const params = new URLSearchParams(parsedUrl.search);

    // 判断是否存在指定的参数名，并返回其值或空字符串
    return params.has(paramName) ? params.get(paramName) : '';
}

function copy(text, callback) {
    // 现代浏览器 clipboard API 方案
    const modernCopy = () => {
        navigator.clipboard.writeText(text).then(() => {
            message("复制成功")
            callback && callback(null)
        }).catch(err => {
            console.error('现代API复制失败，尝试降级方案:', err)
            legacyCopy() // 现代API失败时降级
        })
    }

    // 传统 execCommand 方案
    const legacyCopy = () => {
        try {
            // 创建临时文本域
            const textarea = document.createElement('textarea')
            textarea.value = text
            textarea.setAttribute('readonly', '')      // 防止移动端键盘弹出
            textarea.style.position = 'absolute'
            textarea.style.left = '-9999px'           // 移出可视区域
            textarea.style.fontSize = '12pt'           // 修复iOS复制禁用问题

            // 选择逻辑
            document.body.appendChild(textarea)
            const selection = document.getSelection()
            const range = document.createRange()

            // 兼容iOS选区设置
            if (textarea.setSelectionRange) {
                textarea.setSelectionRange(0, 9999)
            } else {
                textarea.select()
            }

            // 双重保障选区设置
            range.selectNodeContents(textarea)
            selection.removeAllRanges()
            selection.addRange(range)

            // 执行复制
            const success = document.execCommand('copy')
            document.body.removeChild(textarea)
            selection.removeAllRanges()

            success
                ? message("复制成功") && callback && callback(null)
                : callback && callback(new Error('复制操作被拒绝'))
        } catch (err) {
            callback && callback(err)
        }
    }

    // 安全上下文判断（https/localhost）
    if (navigator.clipboard && window.isSecureContext) {
        modernCopy()
    } else {
        // 非安全上下文直接使用传统方案
        legacyCopy()
    }
}

export default Vue.prototype.$Common = Common
